<template>
  <path pid="0" d="M12 8H3a1 1 0 000 2h9a3 3 0 10-2.12-5.11 1 1 0 001.42 1.4A1 1 0 1112 8zM15.51 19.87a1 1 0 01-1.21-.17 1 1 0 00-1.42 1.41A3 3 0 1015 16H3a1 1 0 000 2h12a1 1 0 011 .74 1 1 0 01-.49 1.13z"/><path pid="1" d="M23.88 11.4A3.5 3.5 0 0018 8a1 1 0 101.41 1.42A1.5 1.5 0 1120.5 12H3a1 1 0 000 2h17.5a3.5 3.5 0 003.38-2.6z"/>
</template>
